import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

const TO_CHECK = {
  color: '#964b00',
  label: <FormattedMessageWrapper id="A vérifier" />,
  reference: 'TO_CHECK',
  value: 1,
};

const PENDING_INFORMATIONS = {
  color: '#e67e22',
  label: <FormattedMessageWrapper id="En attente d'informations" />,
  reference: 'PENDING_INFORMATIONS',
  value: 2,
};

const CHECKED = {
  color: '#2ecc71',
  label: <FormattedMessageWrapper id="Validé" />,
  reference: 'CHECKED',
  value: 3,
};

const CHECKED_WITH_OPTION = {
  color: '#3498db',
  label: <FormattedMessageWrapper id="Vérifié avec dérogation" />,
  reference: 'CHECKED_WITH_OPTION',
  value: 4,
};

const REFUSED = {
  color: '#e74c3c',
  label: <FormattedMessageWrapper id="Refusé" />,
  reference: 'REFUSED',
  value: 5,
};

const statuses = {
  CHECKED,
  CHECKED_WITH_OPTION,
  TO_CHECK,
  // eslint-disable-next-line sort-keys
  PENDING_INFORMATIONS,
  REFUSED,
};

export default statuses;

export const getStandDocumentMediaStatusColor = (reference: string) => {
  return statuses[reference as keyof typeof statuses]?.color;
}

export const getStandDocumentMediaStatusLabel = (reference: string) => {
  return statuses[reference as keyof typeof statuses]?.label;
}
